<header>
    <div class="collapse bg-dark" id="navbarHeader">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-md-7 py-4">
            <h4 class="text-white">About</h4>
            <p class="text-muted">Jon Ray Building commenced trading in 1994 and became a limited company at the end of 2002.
                The Company uses a regular group of experienced craftsmen, used to working together as a team, and takes responsibility 
                for all building trades, including plumbing, heating and electrical services, together with the supply and installation 
                of high quality joinery.
            </p>
          </div>
          <div class="col-sm-4 offset-md-1 py-4">
            <h4 class="text-white">Links</h4>
            <ul class="list-unstyled">
              <li><a routerLink="/about" data-toggle="collapse" data-target="#navbarHeader" class="text-white">About us</a></li>
              <li><a routerLink="/services" data-toggle="collapse" data-target="#navbarHeader" class="text-white">Services</a></li>
              <li><a routerLink="/portfolio" data-toggle="collapse" data-target="#navbarHeader" class="text-white">Portfolio</a></li>
              <li><a routerLink="/contact" data-toggle="collapse" data-target="#navbarHeader" class="text-white">Contact us</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar navbar-dark bg-dark shadow-sm">
      <div class="container d-flex justify-content-between no-padding-left">
        <a href="index.html" class="navbar-brand d-flex align-items-center">
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" aria-hidden="true" class="mr-2" viewBox="0 0 24 24" focusable="false"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>-->
          <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 48 48" id="icon-home">
            <g>
              <path id="path1" transform="rotate(0,24,24) translate(11,15.3062493801117) scale(0.8125,0.8125)" fill="#B71000" d="M16.100006,5.3000026L27.100006,12.600005 27.100006,21.400001 19.800018,21.400001 19.800018,13.999999 12.600006,13.999999 12.600006,21.400001 4.8000183,21.400001 4.8000183,12.600005z M16,0L23.5,4.9999995 23.5,2.4000015 27,2.4000015 27,7.3000026 32,10.600005 29.800018,12.400001 16,3.3000031 2.2000122,12.400001 0,10.600005z" />
            </g>
          </svg>         
          <strong class="company">Jon Ray Building Ltd</strong>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarHeader" aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </div>
</header>

<main role="main">
    <router-outlet></router-outlet>
</main>

<footer>
    <div class="container">
        <p>
          <span>Jon Ray Building Ltd
            <ul id="phone-numbers">
              <li *ngFor="let p of phones"><a href="tel:{{p}}">{{p}}</a></li>
            </ul>
        </span>
      </p>
    </div>
</footer>
<!--
<div class="fixed-bottom p-4">
  <div class="toast bg-dark text-white w-100 mw-100" role="alert" data-autohide="false">
      <div class="toast-body p-4 d-flex flex-column">
          <h4>Cookie Warning</h4>
          <p>
          This website stores data such as cookies to enable site functionality including analytics and personalization. By using this website, you automatically accept that we use cookies. 
          </p>
          <div class="ml-auto">
              <button type="button" class="btn btn-outline-light mr-3" id="btnDeny">
                  Deny
              </button>
              <button type="button" class="btn btn-light" id="btnAccept">
                  Accept
              </button>
          </div>
      </div>
  </div>
</div>
-->